import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const navLinkStyle = (path) => ({
    color: isActive(path) ? '#3b82f6' : '#1e3a8a',
    fontWeight: isActive(path) ? '800' : '600',
    fontSize: '1.05rem',
    padding: '0.5rem 1rem',
    borderRadius: '8px',
    transition: 'all 0.3s',
    background: isActive(path) ? '#dbeafe' : 'transparent'
  });

  return (
    <header style={{
      background: 'white',
      boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
      position: 'sticky',
      top: 0,
      zIndex: 1000,
      borderBottom: '3px solid #3b82f6'
    }}>
      <nav style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '1.25rem 2rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        {/* Logo */}
        <Link to="/" style={{
          fontSize: '1.8rem',
          fontWeight: '900',
          color: '#1e40af',
          display: 'flex',
          alignItems: 'center',
          gap: '0.75rem'
        }}>
          <span style={{fontSize: '2.5rem'}}>📋</span>
          <span>Ursus Victor LLC</span>
        </Link>

        {/* Desktop Navigation */}
        <div style={{
          display: 'flex',
          gap: '0.5rem',
          alignItems: 'center'
        }} className="desktop-nav">
          <Link to="/" style={navLinkStyle('/')}>Home</Link>
          <Link to="/about" style={navLinkStyle('/about')}>About</Link>
          <Link to="/services" style={navLinkStyle('/services')}>Services</Link>
          <Link to="/resources" style={navLinkStyle('/resources')}>Resources</Link>
          <Link to="/faq" style={navLinkStyle('/faq')}>FAQ</Link>
          <Link to="/contact" style={{
            background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
            color: 'white',
            padding: '0.75rem 1.75rem',
            borderRadius: '10px',
            fontWeight: '800',
            fontSize: '1.05rem',
            marginLeft: '0.5rem',
            boxShadow: '0 4px 12px rgba(30,64,175,0.3)'
          }}>
            Get Support
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          style={{
            display: 'none',
            background: '#3b82f6',
            color: 'white',
            border: 'none',
            padding: '0.75rem',
            borderRadius: '8px',
            fontSize: '1.5rem',
            cursor: 'pointer'
          }}
          className="mobile-menu-btn"
        >
          {isMenuOpen ? '✕' : '☰'}
        </button>
      </nav>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div style={{
          background: 'white',
          padding: '1.5rem 2rem',
          borderTop: '2px solid #e2e8f0'
        }} className="mobile-nav">
          <div style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
            <Link to="/" style={{...navLinkStyle('/'), display: 'block'}} onClick={() => setIsMenuOpen(false)}>
              Home
            </Link>
            <Link to="/about" style={{...navLinkStyle('/about'), display: 'block'}} onClick={() => setIsMenuOpen(false)}>
              About
            </Link>
            <Link to="/services" style={{...navLinkStyle('/services'), display: 'block'}} onClick={() => setIsMenuOpen(false)}>
              Services
            </Link>
            <Link to="/resources" style={{...navLinkStyle('/resources'), display: 'block'}} onClick={() => setIsMenuOpen(false)}>
              Resources
            </Link>
            <Link to="/faq" style={{...navLinkStyle('/faq'), display: 'block'}} onClick={() => setIsMenuOpen(false)}>
              FAQ
            </Link>
            <Link to="/contact" style={{
              background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
              color: 'white',
              padding: '1rem',
              borderRadius: '10px',
              fontWeight: '800',
              textAlign: 'center',
              display: 'block'
            }} onClick={() => setIsMenuOpen(false)}>
              Get Support
            </Link>
          </div>
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .desktop-nav {
            display: none !important;
          }
          .mobile-menu-btn {
            display: block !important;
          }
        }
      `}</style>
    </header>
  );
};

export default Header;
